import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  notificationFail,
  notificationSuccess,
} from "../slices/notificationSlice";
import {
  deviceList,
  configureList,
  setLoader,
  configureListNew,
  deviceWithConfigured,
} from "../slices/deviceSlice";
import axios from "axios";
import { API, graphqlOperation } from "aws-amplify";
import {
  configNewDevice,
  disconnectDeviceMutation,
  deleteLocationsMutation,
  linkDevices,
  linkMultiDevices,
  recoverLocationsMutation,
  configDeviceNew,
  configureNewDeviceMutatiom,
  disconnectMultipleDeviceMutation,
  unlinkMultipleDeviceMutation,
  removeRoomFromUnitMutation,
} from "../../graphql/mutations";
import {
  getAllDevicesData,
  getConfiguredDeviceList,
  getConfiguredDeviceListNew,
  getConfigutedDeviceWithLocationQuery,
  unLinkRoom,
} from "../../graphql/queries";
import { getLocationLists } from "./locationThunk";
import {
  qaApi,
  prodApi,
  devApi
} from "../../aws-export";
import { ChangeServiceRequest } from "./commonThunk";

export const Fakedevices =
{
  data: [{
    id: 'fake_dev_1',
    attributes: {
      name: 'Fake Device 1', agent_running: 'yes', device_online: true, ip_address: '', iccid: ''
    },
    relationships: {
      devicegroup: { type: '' }
    }
  }, {
    id: 'fake_dev_2',
    attributes: {
      name: 'Fake Device 2', agent_running: 'yes', device_online: true, ip_address: '', iccid: ''
    },
    relationships: {
      devicegroup: { type: '' }
    }
  }, {
    id: 'fake_dev_3',
    attributes: {
      name: 'Fake Device 3', agent_running: 'yes', device_online: true, ip_address: '', iccid: ''
    },
    relationships: {
      devicegroup: { type: '' }
    }
  },
  {
    id: 'fake_dev_4',
    attributes: {
      name: 'Fake Device 4', agent_running: 'yes', device_online: true, ip_address: '', iccid: ''
    },
    relationships: {
      devicegroup: { type: '' }
    }
  },
    // {
    //   id:'fake_dev_5',
    //   attributes:{
    //     name:'Fake Device 5', agent_running:'yes', device_online: true,ip_address:'', iccid:''
    //   },
    //   relationships:{
    //     devicegroup:{type:''}
    //   }
    // },{
    //   id:'fake_dev_6',
    //   attributes:{
    //     name:'Fake Device 6', agent_running:'yes', device_online: true,ip_address:'', iccid:''
    //   },
    //   relationships:{
    //     devicegroup:{type:''}
    //   }
    // },{
    //   id:'fake_dev_7',
    //   attributes:{
    //     name:'Fake Device 7', agent_running:'yes', device_online: true,ip_address:'', iccid:''
    //   },
    //   relationships:{
    //     devicegroup:{type:''}
    //   }
    // },{
    //   id:'fake_dev_8',
    //   attributes:{
    //     name:'Fake Device 8', agent_running:'yes', device_online: true,ip_address:'', iccid:''
    //   },
    //   relationships:{
    //     devicegroup:{type:''}
    //   }
    // },{
    //   id:'fake_dev_9',
    //   attributes:{
    //     name:'Fake Device 9', agent_running:'yes', device_online: true,ip_address:'', iccid:''
    //   },
    //   relationships:{
    //     devicegroup:{type:''}
    //   }
    // },{
    //   id:'fake_dev_10',
    //   attributes:{
    //     name:'Fake Device 10', agent_running:'yes', device_online: true,ip_address:'', iccid:''
    //   },
    //   relationships:{
    //     devicegroup:{type:''}
    //   }
    // }
  ]
}

export const getAllDevices = createAsyncThunk("getAllDevices", async (_request: any, { dispatch }) => {

  try {
    const loginwithtype = localStorage.getItem("loginwith") || "";
    dispatch(
      ChangeServiceRequest({
        request:
          loginwithtype === "qa"
            ? qaApi
            : loginwithtype === "prod"
              ? prodApi
              : devApi,
      })
    );
    dispatch(setLoader(true));
    const listDeviceData = (await API.graphql({
      ...graphqlOperation(getAllDevicesData),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    })) as { data: any; errors: any[] };
    let deviceDatares: any = { data: [...Fakedevices.data] };
    // let deviceDatares:any = { data: [] };
    if (listDeviceData.data.getAllDevices) {
      deviceDatares.data = [...deviceDatares.data, ...listDeviceData.data.getAllDevices]
    }
    dispatch(deviceList(deviceDatares));
    dispatch(setLoader(false));
  } catch (error) {
    // let deviceDatares:any = {data:[...Fakedevices.data]};
    let deviceDatares: any = { data: [] };
    dispatch(deviceList(deviceDatares));
    dispatch(setLoader(false));
  }

  // const headers = {
  //   "Content-Type": "application/json",
  // };

  // //494d7935447e9257
  // axios
  //   .post(
  //     "https://api.electricimp.com/v5/auth/token",
  //     { key: "2ef81d91506862c5" },
  //     {
  //       headers: headers,
  //     }
  //   )
  //   .then((response): any => {
  //     if (response.data.access_token) {
  //       axios.defaults.headers.common["Authorization"] =
  //         "Bearer " + response.data.access_token;
  //       axios.defaults.headers.common["accept"] = "application/vnd.api+json";

  //       axios
  //         .get("https://api.electricimp.com/v5/devices")
  //         .then(function (response: any) {
  //           let deviceDatares = response;
  //           deviceDatares.data = [...deviceDatares.data.data, ...Fakedevices.data]
  //           dispatch(deviceList(deviceDatares));
  //           dispatch(setLoader(false));
  //         });
  //     }
  //   })
  //   .catch((error) => {
  //     dispatch(notificationFail("Something went Wrong"));
  //     dispatch(setLoader(false));
  //   });
}
);

export const configDevice = createAsyncThunk(
  "configDevice",
  async (_request: any, { dispatch }) => {
    dispatch(setLoader(true));
    const list = (await API.graphql({
      ...graphqlOperation(configNewDevice, { deviceConfig: _request.request }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    })) as { data: any; errors: any[] };

    if (_request.callback) {
      _request.callback();
    }

    dispatch(getConfiguredDevices({ code: _request.request.tenantCode }));
    if (list.data.configureDevice.success === "true") {
      dispatch(
        notificationSuccess("Device Configuration Updated Successfully")
      );
    } else {
      dispatch(notificationFail("Device Already Configured in another room"));
    }
    dispatch(setLoader(false));
  }
);

export const getConfiguredDevices = createAsyncThunk(
  "getConfiguredDevices",
  async (_request: any, { dispatch }) => {
    dispatch(setLoader(true));
    const list = (await API.graphql({
      ...graphqlOperation(getConfiguredDeviceList, {
        tenantCode: _request.code,
      }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    })) as { data: any; errors: any[] };

    dispatch(configureList(list.data));
    dispatch(setLoader(false));
  }
);

export const recoverLocation = createAsyncThunk(
  "recoverLocation",
  async (_request: any, { dispatch }) => {
    try {
      const data = (await API.graphql({
        ...graphqlOperation(recoverLocationsMutation, {
          recoverLocation: _request.request,
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };

      if (_request.callback) {
        _request.callback();
      }
      if (data.data.recoverLocation.success === "true") {
        dispatch(notificationSuccess("Location Recovered successfully"));

        dispatch(getConfiguredDevices({ code: _request.tenantCode }));
      } else {
        dispatch(notificationFail("Something went wrong"));
      }
    } catch {
      dispatch(notificationFail("Something went wrong"));
    }
  }
);

export const deleteLocations = createAsyncThunk(
  "deleteLocations",
  async (_request: any, { dispatch }) => {
    try {
      const data = (await API.graphql({
        ...graphqlOperation(deleteLocationsMutation, {
          deleteLocation: _request.request,
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };

      if (_request.callback) {
        _request.callback();
      }
      if (data.data.deleteLocations.success === "true") {
        if (_request.type === "S") {
          dispatch(
            notificationSuccess(
              "System and all its data are Deleted successfully"
            )
          );
        } else if (_request.type === "F") {
          dispatch(
            notificationSuccess(
              "Facility and all its data are Deleted successfully"
            )
          );
        } else if (_request.type === "L") {
          dispatch(
            notificationSuccess(
              "Floor and all its data are Deleted successfully"
            )
          );
        } else if (_request.type === "U") {
          dispatch(
            notificationSuccess(
              "Department and all its data are Deleted successfully"
            )
          );
        } else if (_request.type === "R") {
          dispatch(notificationSuccess("Room Delete Successfully"));
        } else if (_request.type === "delete") {
          dispatch(notificationSuccess("All Locations Delete Successfully"));
        } else if (_request.type === "unassign") {
          dispatch(notificationSuccess("Device Unassigned Successfully"));
        }

        dispatch(getConfiguredDevices({ code: _request.tenantCode }));
      } else {
        dispatch(notificationFail("Something went wrong"));
      }
    } catch {
      dispatch(notificationFail("Something went wrong"));
    }
  }
);

export const disconnectDevice = createAsyncThunk(
  "disconnectDevice",
  async (_request: any, { dispatch }) => {
    try {
      const data = (await API.graphql({
        ...graphqlOperation(disconnectDeviceMutation, {
          device: _request.request,
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };

      if (_request.callback) {
        _request.callback();
      }
      if (data.data.disconnectDevice.success === "true") {
        if (_request.request.tenantCode.substring(0, 1) === "S") {
          dispatch(notificationSuccess("System Delete Successfully"));
        } else if (_request.request.tenantCode.substring(0, 1) === "F") {
          dispatch(notificationSuccess("Facility Delete Successfully"));
        } else if (_request.request.tenantCode.substring(0, 1) === "L") {
          dispatch(notificationSuccess("Floor Delete Successfully"));
        } else if (_request.request.tenantCode.substring(0, 1) === "U") {
          dispatch(notificationSuccess("Department Delete Successfully"));
        } else if (_request.request.tenantCode.substring(0, 1) === "R") {
          dispatch(notificationSuccess("Room Delete Successfully"));
        } else {
          dispatch(notificationSuccess("Connfiguration Delete Successfully"));
        }
        dispatch(getConfiguredDevicesNew({ tenantCode: _request.tenantCode }));
        dispatch(getLocationLists({ tenantId: _request.tenantCode }));
      } else {
        dispatch(notificationFail("Something went wrong"));
      }
    } catch {
      dispatch(notificationFail("Something went wrong"));
    }
  }
);

export const linkDevicesLocation = createAsyncThunk(
  "linkDevice",
  async (_request: any, { dispatch }) => {
    dispatch(setLoader(true));

    const list = (await API.graphql({
      ...graphqlOperation(linkDevices, { devicesImport: _request.request }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    })) as { data: any; errors: any[] };

    if (_request.callback) {
      _request.callback();
    }

    dispatch(getConfiguredDevices({ code: _request.request.tenant_code }));
    if (list.data.devicesImport.success === "true") {
      dispatch(
        notificationSuccess("Device Configuration Updated Successfully")
      );
    } else {
      dispatch(notificationFail("Device Already Configured in another room"));
    }
    dispatch(setLoader(false));
  }
);

export const unconfigDevice = createAsyncThunk(
  "unLinkRoom",
  async (_request: any, { dispatch }) => {
    dispatch(setLoader(true));

    const list = (await API.graphql({
      ...graphqlOperation(unlinkMultipleDeviceMutation, {
        unlinkDevices: { unlinkDevices: _request.request },
      }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    })) as { data: any; errors: any[] };

    if (_request.callback) {
      _request.callback();
    }
    dispatch(getConfiguredDevicesNew({ tenantCode: _request.tenantCode }));
    if (list.data.unlinkMultipleDevice.success === "true") {
      dispatch(notificationSuccess("Room is Unlink Successfully"));
    } else {
      dispatch(notificationFail("Something is wrong"));
    }
    dispatch(setLoader(false));
  }
);

export const linkMultiRooms = createAsyncThunk(
  "linkMultiRoom",
  async (_request: any, { dispatch }) => {
    dispatch(setLoader(true));
    const list = (await API.graphql({
      ...graphqlOperation(linkMultiDevices, {
        linkDevices: { linkDevices: _request.request },
      }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    })) as { data: any; errors: any[] };

    if (list.data.linkDevices.success === "true") {
      dispatch(notificationSuccess("Rooms linked Successfully"));
      dispatch(getConfiguredDevicesNew({ tenantCode: _request.tenantCode }));
    } else {
      dispatch(notificationFail("Opps! Rooms is not linked"));
    }
    if (_request.callback) {
      _request.callback();
    }
    dispatch(setLoader(false));
  }
);

export const configureNewdevice = createAsyncThunk(
  "configureNewdevice",
  async (_request: any, { dispatch }) => {
    dispatch(setLoader(true));

    const list = (await API.graphql({
      ...graphqlOperation(configDeviceNew, { configDevices: _request.request }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    })) as { data: any; errors: any[] };

    if (list.data.configDeviceNew.success === "true") {
      dispatch(notificationSuccess("Device Configured"));
      if (_request.callback) {
        _request.callback();
      }
    } else {
      dispatch(notificationFail("Device Already Configured"));
    }

    dispatch(setLoader(false));
  }
);

export const getConfiguredDevicesNew = createAsyncThunk(
  "getConfiguredDevicesNew",
  async (_request: any, { dispatch }) => {
    dispatch(setLoader(true));
    const loginwithtype = localStorage.getItem("loginwith") || "";
    dispatch(
      ChangeServiceRequest({
        request: loginwithtype === "qa"
          ? qaApi
          : loginwithtype === "prod"
            ? prodApi
            : devApi,
      })
    );
    try {
      const list = (await API.graphql({
        ...graphqlOperation(getConfiguredDeviceListNew, {
          tenantCode: _request.tenantCode,
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };
      if (list?.data?.getConfiguredDeviceNew) {
        dispatch(configureListNew(list.data.getConfiguredDeviceNew));
        if (_request.callback) {
          _request.callback();
        }
      }
    } catch (err) {
      dispatch(notificationFail("Something is wrong"));
    }
    dispatch(setLoader(false));
  }
);

export const configDeviceNewThunk = createAsyncThunk(
  "configDeviceNew",
  async (_request: any, { dispatch }) => {
    dispatch(setLoader(true));
    const list = (await API.graphql({
      ...graphqlOperation(configureNewDeviceMutatiom, {
        deviceConfigNew: _request.request,
      }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    })) as { data: any; errors: any[] };

    if (_request.callback) {
      _request.callback();
    }
    dispatch(
      getConfiguredDevicesNew({ tenantCode: _request.request.tenantCode })
    );
    if (list.data.configureNewDevice.success === "true") {
      dispatch(
        notificationSuccess("Device Configuration Updated Successfully")
      );
    } else {
      dispatch(notificationFail("Same Device is not Configure this Location"));
    }
    dispatch(setLoader(false));
  }
);

export const disconnectMultipleDevice = createAsyncThunk(
  "disconnectMultipleDevice",
  async (_request: any, { dispatch }) => {
    try {
      const list = (await API.graphql({
        ...graphqlOperation(disconnectMultipleDeviceMutation, {
          disconnectDevices: { disconnectDevices: _request.request },
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };

      if (list.data.disconnectMultipleDevice.success === "true") {
        dispatch(getConfiguredDevicesNew({ tenantCode: _request.tenantCode }));
        dispatch(notificationSuccess("Device Disconnect"));
      } else {
        dispatch(notificationFail("Opps! Devices Not Disconnect"));
      }
    } catch (error) {
      dispatch(notificationFail("Something went wrong"));
    }
  }
);

export const removeRoomFromUnitThunk = createAsyncThunk(
  "removeRoomFromUnit",
  async (_request: any, { dispatch }) => {
    try {
      const data = (await API.graphql({
        ...graphqlOperation(removeRoomFromUnitMutation, {
          removeRoomFromUnit: _request.request,
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };

      if (_request.callback) {
        _request.callback();
      }
      if (data.data.removeRoomFromUnit.success === "true") {
        dispatch(notificationSuccess("Room Removed From Unit"));
      } else {
        dispatch(notificationFail("Something went wrong"));
      }
    } catch {
      dispatch(notificationFail("Something went wrong"));
    }
  }
);
export const getConfiguredDeviceWithLocationThunk = createAsyncThunk("getConfiguredDeviceWithLocation", async (_request: any, { dispatch }) => {
  try {
    const data = (await API.graphql({
      ...graphqlOperation(getConfigutedDeviceWithLocationQuery),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    })) as { data: any; errors: any[] };
    return data.data.getConfigutedDeviceWithLocation

  } catch (error) {

  }
}
);